import axiosInstance from '@/lib/axiosInstance';
import { QuotaLimitResponse } from './type';
import { AxiosPromise } from 'axios';

export const getQuotaLimit= async () => {
  const { data } = await axiosInstance.post<
    QuotaLimitResponse,
    AxiosPromise<QuotaLimitResponse>
  >('/dedicate/get_user_quota');
  return data;
};
